import axios from '@/libs/api.request'
// 学生端预约接口
const serviceService = {
  // 导师辅导-待确认导师列表
  checkHasAppointment (data) {
    return axios.request({
      url: '/ugd/appointment/check',
      data,
      method: 'POST'
    })
  },
  // 导师辅导-待确认导师列表
  appointUncomfirmList (data) {
    return axios.request({
      url: '/ugd/mr/tbc',
      data,
      method: 'POST'
    })
  },
  // 导师辅导-待确认导师-点击
  appointUncomfirmSub (data) {
    return axios.request({
      url: '/ugd/mr/confirm',
      data,
      method: 'POST'
    })
  },
  // 导师辅导-未开始预约列表
  appointNotStartedList (data) {
    return axios.request({
      url: '/ugd/appointment/notStarted/list',
      data,
      method: 'POST'
    })
  },
  // 导师辅导-已完成预约列表
  appointFinishList (data) {
    return axios.request({
      url: '/ugd/appointment/finish/list',
      data,
      method: 'POST'
    })
  },
  // 导师辅导-预约-等待导师确认-列表
  appointComfirmMentorList: data => {
    return axios.request({
      url: '/ugd/appointment/waitMentorConfirm/list',
      data,
      method: 'post'
    })
  },
  // 导师辅导-预约-等待学员确认-列表
  appointComfirmMenteeList: data => {
    return axios.request({
      url: '/ugd/appointment/waitMenteeConfirm/list',
      data,
      method: 'post'
    })
  },
  // 导师辅导-预约-等待学员确认-提交
  appointComfirmMenteeSub: data => {
    return axios.request({
      url: '/ugd/appointment/confirm',
      data,
      method: 'post'
    })
  },
  // 服务团队-套餐信息
  servicePackageDetail (data) {
    return axios.request({
      url: '/ugd/info/packages',
      data,
      method: 'POST'
    })
  },
  serviceMenteeDetail (data) {
    return axios.request({
      url: '/ugd/info/detail',
      data,
      method: 'POST'
    })
  },
  // 服务团队-导师列表
  serviceTeamMentorList (data) {
    return axios.request({
      url: '/ugd/joint/map/all',
      data,
      method: 'POST'
    })
  },
  // 服务团队-导师简介列表
  serviceTeamIntroductionList (data) {
    return axios.request({
      url: '/ugd/info/team',
      data,
      method: 'POST'
    })
  },
  // 服务团队-判断套餐时间够不够的接口
  serviceTeamMenteeTime (data) {
    return axios.request({
      url: '/ugd/appointment/queryPackageTimeMeet',
      data,
      method: 'POST'
    })
  },
  // 通过选中模块计算剩余时间是否充足
  serviceTeamModuleResidueTime (data) {
    return axios.request({
      url: '/ugd/appointment/residue/time',
      data,
      method: 'POST'
    })
  },
  // 服务团队-创建预约-提交
  serviceTeamAppoint (data) {
    return axios.request({
      url: '/ugd/appointment/create',
      data,
      method: 'POST'
    })
  }
}

export default serviceService
